import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo-converza.png'
import _imports_1 from '../assets/bg_login_reduce.jpg'


const _hoisted_1 = { class: "flex md:flex-row max-md:flex-col h-screen overflow-hidden max-sm:overflow-y-auto" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"md:hidden w-full h-full\"></div><div class=\"flex justify-center items-center w-full h-1/3 md:hidden\"><img src=\"" + _imports_0 + "\" alt=\"Logo\" class=\"p-8 aspect-auto w-2/3\"></div><div class=\"w-full h-full max-md:hidden\"><img src=\"" + _imports_1 + "\" class=\"block w-full h-full object-cover bg-gradient-to-r from-[#e0e3f5] to-[#e5e9f9]\"></div>", 3)
const _hoisted_5 = { class: "w-full h-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-full md:hidden" }, null, -1)

import LoginComponent from '@/components/auth/LoginComponent.vue';
import RegisterComponent from '@/components/auth/RegisterComponent.vue';
import { CLEAR_AUTH, GET_CREDENTIALS, GET_WHO_AM_I, PARTNER_ID } from '@/store';
import { set } from '@vueuse/core';
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthView',
  setup(__props) {

const isLogin = ref(true);
const step = ref<number>(1);
const { commit, getters } = useStore();

const toggleRegistrationEvent = (event: Event | undefined) => {
  event?.preventDefault();

  isLogin.value = !isLogin.value;

  commit(CLEAR_AUTH);
};

const goToPartnerRegistration = (event?: Event) => {
  event?.preventDefault();
  set(isLogin, false);
  set(step, 2);
};

onMounted(() => {
  if (getters[GET_CREDENTIALS] != undefined && getters[GET_WHO_AM_I] != undefined && getters[PARTNER_ID] == undefined) {
    goToPartnerRegistration();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      (isLogin.value)
        ? (_openBlock(), _createBlock(LoginComponent, {
            key: 0,
            onTOGGLE_REGISTRATION: toggleRegistrationEvent,
            onGO_TO_PARTNER_FORM: goToPartnerRegistration
          }))
        : (_openBlock(), _createBlock(RegisterComponent, {
            key: 1,
            onTOGGLE_REGISTRATION: toggleRegistrationEvent,
            modelValue: step.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((step).value = $event))
          }, null, 8, ["modelValue"]))
    ]),
    _hoisted_6
  ]))
}
}

})